import { ChartDisplayElementModel } from '../../../Reports/models/chart-display-element.model';
import { DropdownFieldModel } from '../../../PageBuilder/models/dropdown-field.model';
import { DropdownFieldComponent } from '../../../PageBuilder/components/FormFields/DropdownField/dropdown-field.component';
import { BlockTypeModel } from '../../../PageBuilder/models/block-type.model';
import { ReportBlockTypeEnum } from '../../../Reports/enums/report-block-type.enum';
import { ListChartBlockComponent } from '../../../Reports/components/ListChartBlock/list-chart-block.component';
import { TextFieldModel } from '../../../PageBuilder/models/text-field.model';
import { TextFieldComponent } from '../../../PageBuilder/components/FormFields/TextField/text-field.component';
import { FilterFieldModel } from '../../../PageBuilder/models/filter-field.model';
import { FilterFieldComponent } from '../../../PageBuilder/components/FormFields/FilterField/filter-field.component';
// eslint-disable-next-line max-len
import { ChartDisplaySettingsFieldComponent } from '../../../Reports/components/ChartDisplaySettingsField/chart-display-settings-field.component';
import { ChartHeaderElementsEnum } from '../../../Charts/models/chart-display-settings.model';
import { ChartDisplaySettingsFieldModel } from '../../../Reports/models/chart-display-settings-field.model';
import { DateRangeFieldModel } from '@Common/Reports/models/date-range-field.model';
import { DateRangeFieldNoSeriesComponent } from '@Common/Reports/components/DateRangeNoSeries/date-range-field-no-series.component';

// Recent Surge Activity
export const recentSurgeActivityBlockType: BlockTypeModel = new BlockTypeModel(
    ReportBlockTypeEnum.RECENT_SURGE_ALERTS,
    `Dashboard.chart.title.${ReportBlockTypeEnum.RECENT_SURGE_ALERTS}`,
    'fa fa-th-list',
    null,
    ChartDisplayElementModel,
    [
        new TextFieldModel(
            TextFieldComponent,
            'title',
            'Reports.formField.chartTitle',
            null,
            false,
            64,
            'Reports.formField.chartTitle.placeholder'
        ),
        new DropdownFieldModel(
            DropdownFieldComponent,
            'numOfItems',
            'Dashboard.field.numberOfItems',
            null,
            [
                {label: '1', value: 1},
                {label: '2', value: 2},
                {label: '3', value: 3},
                {label: '4', value: 4},
                {label: '5', value: 5},
                {label: '6', value: 6},
                {label: '7', value: 7},
                {label: '8', value: 8},
            ]
        ),
        new DateRangeFieldModel(
            DateRangeFieldNoSeriesComponent,
            'dateRange',
            'Reports.formField.dateRange.label',
            '',
            false
        ),
        new FilterFieldModel(
            FilterFieldComponent,
            'contentFilters',
            'Dashboard.field.filter.contentFilters',
            'Dashboard.field.filter.quicksearch.placeholder',
        ),
        new ChartDisplaySettingsFieldModel(
            'chartHeaderSettings',
            ChartDisplaySettingsFieldComponent,
            'Reports.chartSetupDialog.displaySettings',
            '',
            [ChartHeaderElementsEnum.TITLE]
        )
    ],
    ListChartBlockComponent
);
